import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance1gyofnv0sdcf8 as Data_getInstance } from './adapter/SaveSlackIntegrationMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SaveSlackIntegrationMutation_VariablesAdapter_instancefepbboesbjux as SaveSlackIntegrationMutation_VariablesAdapter_instance } from './adapter/SaveSlackIntegrationMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveSlackIntegration) {
        this.e6i_1 = saveSlackIntegration;
      }
      toString() {
        return 'Data(saveSlackIntegration=' + this.e6i_1 + ')';
      }
      hashCode() {
        return this.e6i_1 == null ? 0 : getBooleanHashCode(this.e6i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.e6i_1 == other.e6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.f6i_1 = 'bd60e2fc51a5eb05ff72feb92a37fd76f39156d11bc99c67d8ace2bc096f60f8';
        this.g6i_1 = 'saveSlackIntegration';
      }
      r6f() {
        return 'mutation saveSlackIntegration($input: SaveSlackIntegrationInput!) { saveSlackIntegration(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SaveSlackIntegrationMutationClass;
function SaveSlackIntegrationMutation() {
  if (SaveSlackIntegrationMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.h6i_1 = input;
      }
      t6f() {
        return 'bd60e2fc51a5eb05ff72feb92a37fd76f39156d11bc99c67d8ace2bc096f60f8';
      }
      operationId() {
        return this.t6f();
      }
      l48() {
        return Companion_instance.r6f();
      }
      u6f() {
        return 'saveSlackIntegration';
      }
      operationName() {
        return this.u6f();
      }
      f47(writer, customScalarAdapters, withDefaultValues) {
        SaveSlackIntegrationMutation_VariablesAdapter_instance.i6i(writer, this, customScalarAdapters, withDefaultValues);
      }
      e47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SaveSlackIntegrationMutation(input=' + this.h6i_1.toString() + ')';
      }
      hashCode() {
        return this.h6i_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationMutation()))
          return false;
        if (!this.h6i_1.equals(other.h6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationMutation', VOID, VOID, [Mutation()]);
    SaveSlackIntegrationMutationClass = $;
  }
  return SaveSlackIntegrationMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1y07t6g0k0psd,
  SaveSlackIntegrationMutation as SaveSlackIntegrationMutation39ifsawios99y,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationMutation.mjs.map
